export const RETRY_PUBLISH_TIMEOUT = 300; // 5 минут

export const AUTOFILL_FIELDS_MAP: Record<string, string> = {
  area: 'land_sq',
  totalArea: 'house_sq',
  isDacha: 'house_type',
  status: 'use_type',
  floorsCount: 'house_stages',
  areaUnitType: 'land_sq_unit',
};

export const NEW_FP_REDIRECT_CATEGORIES = [
  // Продажа вторички
  {
    dealType: 'sale',
    objectType: 'flat',
  },
  // Продажа загородки
  {
    dealType: 'sale',
    objectType: 'house',
  },
  {
    dealType: 'sale',
    objectType: 'houseShare',
  },
  {
    dealType: 'sale',
    objectType: 'townhouse',
  },
  {
    dealType: 'sale',
    objectType: 'land',
  },
  {
    dealType: 'sale',
    objectType: 'cottage',
  },
  {
    dealType: 'rent',
    objectType: 'house',
    rentDuration: 'longTerm',
  },
  {
    dealType: 'rent',
    objectType: 'houseShare',
    rentDuration: 'longTerm',
  },
  {
    dealType: 'rent',
    objectType: 'townhouse',
    rentDuration: 'longTerm',
  },
  {
    dealType: 'rent',
    objectType: 'cottage',
    rentDuration: 'longTerm',
  },
  {
    dealType: 'rent',
    objectType: 'house',
    rentDuration: 'fewMonths',
  },
  {
    dealType: 'rent',
    objectType: 'houseShare',
    rentDuration: 'fewMonths',
  },
  {
    dealType: 'rent',
    objectType: 'townhouse',
    rentDuration: 'fewMonths',
  },
  {
    dealType: 'rent',
    objectType: 'cottage',
    rentDuration: 'fewMonths',
  },
  {
    dealType: 'rent',
    objectType: 'flat',
    rentDuration: 'longTerm',
  },
  {
    dealType: 'rent',
    objectType: 'flat',
    rentDuration: 'long',
  },
  {
    dealType: 'rent',
    objectType: 'flat',
    rentDuration: 'fewMonths',
  },
];
